// extracted by mini-css-extract-plugin
export var measureBox = "_8k-0";